// Review modalları — Review.tsx'ten davranışsız çıkarım (KK feature öncesi refactor).
// JSX gövdeleri birebir taşındı; tek değişiklik state/handler'ların props'a bağlanması.

interface RejectModalProps {
  open: boolean;
  reason: string;
  loading: boolean;
  onReasonChange: (v: string) => void;
  onDismiss: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export function RejectModal(p: RejectModalProps): JSX.Element | null {
  if (!p.open) return null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ background: "rgba(0,0,0,0.4)" }}
      onClick={p.onDismiss}
    >
      <div
        className="rounded-xl p-6 max-w-md w-full mx-4"
        style={{ background: "var(--color-surface)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="mb-2" style={{ fontFamily: "var(--font-display)", fontSize: "1.1rem" }}>
          Bölümü Reddet
        </h3>
        <p className="text-xs mb-3" style={{ color: "var(--color-text-2)" }}>
          Red sebebi zorunlu — yeniden üretim için danışmana yön verir.
        </p>
        <textarea
          value={p.reason}
          onChange={(e) => p.onReasonChange(e.target.value)}
          className="w-full p-2 rounded border text-sm"
          style={{
            borderColor: "var(--color-border)",
            minHeight: 100,
            fontFamily: "var(--font-sans)",
          }}
          placeholder="Örn: Kapsam 3 emisyonları net belirtilmemiş, eklenmeli"
        />
        <div className="flex justify-end gap-2 mt-3">
          <button
            onClick={p.onCancel}
            className="px-3 py-1.5 rounded-md text-sm"
            style={{ border: "1px solid var(--color-border)" }}
          >
            Vazgeç
          </button>
          <button
            onClick={p.onConfirm}
            disabled={p.reason.trim().length < 5 || p.loading}
            className="px-3 py-1.5 rounded-md text-sm disabled:opacity-50"
            style={{ background: "var(--color-error)", color: "white", fontWeight: 600 }}
          >
            Reddet
          </button>
        </div>
      </div>
    </div>
  );
}

interface ReopenModalProps {
  open: boolean;
  reason: string;
  loading: boolean;
  approvedCount: number;
  onReasonChange: (v: string) => void;
  onDismiss: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ReopenModal(p: ReopenModalProps): JSX.Element | null {
  if (!p.open) return null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ background: "rgba(0,0,0,0.4)" }}
      onClick={p.onDismiss}
    >
      <div
        className="rounded-xl p-6 max-w-md w-full mx-4"
        style={{ background: "var(--color-surface)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="mb-2" style={{ fontFamily: "var(--font-display)", fontSize: "1.2rem" }}>
          Projeyi Yeniden Aç
        </h3>
        <p className="text-sm mb-3" style={{ color: "var(--color-text-2)" }}>
          <strong>{p.approvedCount.toString()} onaylı bölümün</strong> onayı kaldırılır ve yeniden
          inceleme bekler hale gelir. Mevcut tüm .docx raporları arşivlenir. Bu işlem audit log'a
          kaydedilir.
        </p>
        <textarea
          value={p.reason}
          onChange={(e) => p.onReasonChange(e.target.value)}
          className="w-full p-2 rounded border text-sm"
          style={{
            borderColor: "var(--color-border)",
            minHeight: 100,
            fontFamily: "var(--font-sans)",
          }}
          placeholder="Reopen sebebi (min 5 karakter) — örn: Müşteri revizyon talebi, yeni veri geldi"
        />
        <div className="flex justify-end gap-2 mt-3">
          <button
            onClick={p.onCancel}
            className="px-3 py-1.5 rounded-md text-sm"
            style={{ border: "1px solid var(--color-border)" }}
          >
            Vazgeç
          </button>
          <button
            onClick={p.onConfirm}
            disabled={p.reason.trim().length < 5 || p.loading}
            className="px-3 py-1.5 rounded-md text-sm disabled:opacity-50"
            style={{
              background: "var(--color-error)",
              color: "white",
              fontWeight: 600,
            }}
          >
            {p.loading ? "İşleniyor…" : "Reopen Et"}
          </button>
        </div>
      </div>
    </div>
  );
}

interface BulkApproveModalProps {
  open: boolean;
  pendingCount: number;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function BulkApproveModal(p: BulkApproveModalProps): JSX.Element | null {
  if (!p.open) return null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ background: "rgba(0,0,0,0.4)" }}
      onClick={p.onCancel}
    >
      <div
        className="rounded-xl p-6 max-w-md w-full mx-4"
        style={{ background: "var(--color-surface)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="mb-2" style={{ fontFamily: "var(--font-display)", fontSize: "1.2rem" }}>
          Tüm Bölümleri Onayla
        </h3>
        <p className="text-sm mb-4" style={{ color: "var(--color-text-2)" }}>
          <strong>{p.pendingCount.toString()} bölümü</strong> bir defada onaylayacaksınız. Bu işlem
          tüm içeriği approved durumuna çeker. Approved bölümler edit edilemez.
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={p.onCancel}
            className="px-3 py-1.5 rounded-md text-sm"
            style={{ border: "1px solid var(--color-border)" }}
          >
            Vazgeç
          </button>
          <button
            onClick={p.onConfirm}
            disabled={p.loading}
            className="px-3 py-1.5 rounded-md text-sm disabled:opacity-50"
            style={{
              background: "var(--color-success)",
              color: "white",
              fontWeight: 600,
            }}
          >
            {p.loading ? "Onaylanıyor…" : "Hepsini Onayla"}
          </button>
        </div>
      </div>
    </div>
  );
}
